import {ORANGE_LIGHTER, ORANGE_POWDER} from 'ui-library/Colors';

export const PLACEHOLDER_TEXT = 'Search document...';
export const DEBOUNCE_INTERVAL_MS = 400;

// Keep in sync with less/mediocre.less
export const SELECTED_SEARCH_RESULT_COLOR = ORANGE_POWDER;
export const SEARCH_RESULT_COLOR = ORANGE_LIGHTER;
